import { ExportFileType } from '@common/ts/enums';
import { Input } from '@/components/ui/input';
import { FileTypeToggleProps } from '@/types';

function ExportFileTypeToggle({ fileType, setFileType }: FileTypeToggleProps) {
  // filteTypes are ['csv', 'txt']
  const filteTypes = Object.values(ExportFileType);

  return (
    <div className="flex gap-2 items-center">
      {filteTypes.map((type) => (
        <div key={type} className="flex items-center gap-1">
          <Input
            type="radio"
            checked={fileType === type}
            onChange={() => setFileType(type)}
            id={`filetype-${type}`}
            className="cursor-pointer shadow-none w-4 h-4"
          />
          <label htmlFor={`filetype-${type}`} className="cursor-pointer text-sm">
            .{type}
          </label>
        </div>
      ))}
    </div>
  );
}

export default ExportFileTypeToggle;
